













import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import {DEFAULT_LABEL_WIDTH, LABEL_ALIGN} from '@/utils/Constants';
import {CaseItemDefault, CaseItemDto} from '@/model/CommonModel';
import CaseInputMixin from '@/components/input/CaseInputMixin';

@Component({
    mixins: [CaseInputMixin]
})
export default class CaseDateTimePicker extends Mixins<CaseInputMixin>(CaseInputMixin) {
    
    public onChangeInput(data: any) {
        this.$emit('input', {...this.value, ['value']: data});
    }
}
